/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DirtyType } from '@gh/common-shared-data';
import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  FinancialIndexes,
  ReportFyaDetailsDto,
  ReportFyaKeyGoalDto,
  ReportFyaThresholdDto,
  ReportRohcAreaDto,
  ReportRohcDetailsDto,
  ReportRohcMasterCostCenterDto,
  ReportRohcOfficeCostCenterDto,
  ReportRohcOfficeDto,
} from './report-settings.dto';

export const ReportRohcOfficeMapper = entity<ReportRohcOfficeDto>({
  dirtyType: enumeration(DirtyType),
});

export const ReportRohcOfficeCostCenterMapper = entity<ReportRohcOfficeCostCenterDto>({
  dirtyType: enumeration(DirtyType),
});

export const ReportRohcDetailsMapper = entity<ReportRohcDetailsDto>({
  areas: arrayOf(subentity<ReportRohcAreaDto>({
    dirtyType: enumeration(DirtyType),
    details: arrayOf(ReportRohcOfficeMapper),
  })),
  masterCostCenters: arrayOf(subentity<ReportRohcMasterCostCenterDto>({
    dirtyType: enumeration(DirtyType),
    details: arrayOf(ReportRohcOfficeCostCenterMapper),
  })),
});

export const ReportFyaThresholdMapper = entity<ReportFyaThresholdDto>({
  type: enumeration(FinancialIndexes),
  dirtyType: enumeration(DirtyType),
});

export const ReportFyaKeyGoalMapper = entity<ReportFyaKeyGoalDto>({
  dirtyType: enumeration(DirtyType),
});

export const ReportFyaDetailsMapper = entity<ReportFyaDetailsDto>({
  thresholds: arrayOf(ReportFyaThresholdMapper),
  keyGoals: arrayOf(ReportFyaKeyGoalMapper),
});
